<template>
  <div class="container">
    <div class="card mb-4">
      <div class="card-header">
        Wybierz program/strefę którą chcesz zarządzać
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-6">
            <select class="form-control" @change="change_program()" v-model="selected_program">
              <option value="0">---</option>
              <option v-for="(name, id) in programs" :value="id">{{ name }}</option>
            </select>
          </div>
          <div class="col-6">
            <select class="form-control" @change="change_program_category()" v-model="selected_program_category">
              <option value="0">---</option>
              <option v-for="(name, id) in program_categories" :value="id">{{ name }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="h5">Przeciągnij artykuły z prawej kolumny „artykuły zawierające lid” na wybraną pozycję do kolumny lewej „Tematy miesiąca”</div>
    <div class="row">
      <div class="col-6">
        <div class="card mb-4">
          <div class="card-header">
            Tematy miesiąca
          </div>
          <div class="card-body">
            <div class="drop-box remove text-danger" @drop="onDrop($event, 0)" @dragover.prevent @dragenter.prevent v-if="new_articles.length">Upuść tutaj, by usunąć</div>
            <div class="drop-box" @drop="onDrop($event, 1)" @dragover.prevent @dragenter.prevent v-if="selected_program || selected_program_category"></div>
            <template v-for="(category, index) in new_articles">
              <div class="drag-box" :id="category.id" draggable @dragstart="startDrag($event, category)">
                {{ category.name }}
              </div>
              <div class="drop-box" @drop="onDrop($event, index + 2)" @dragover.prevent @dragenter.prevent></div>
            </template>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="card">
          <div class="card-header">
            Artykuły zawierające lid
          </div>
          <div class="card-body">
            <div class="drag-box" v-for="category in available_articles" :id="category.id" draggable @dragstart="startDrag($event, category)">
              {{ category.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  mounted() {
    axios.post('/admin/articles/get-programs-list', {}).then(response => {
      this.programs = response.data;
    });
    axios.post('/admin/articles/get-program-categories-list', {}).then(response => {
      this.program_categories = response.data;
    });
  },
  data: function() {
    return {
      test: "asd",
      programs: [],
      selected_program: 0,
      program_categories: [],
      selected_program_category: 0,
      available_articles: [],
      new_articles: [],
      dragging: false
    }
  },
  methods: {
    change_program() {
      if (this.selected_program != 0) {
        this.selected_program_category = 0;
        axios.post('/admin/articles/get-new-articles-list-program', {program_id: this.selected_program}).then(response => {
          this.available_articles = response.data.articles;
          this.new_articles = response.data.new_articles;
        });
      }
    },
    change_program_category() {
      if (this.selected_program_category != 0) {
        this.selected_program = 0;
        axios.post('/admin/articles/get-new-articles-list-program-category', {program_category_id: this.selected_program_category}).then(response => {
          this.available_articles = response.data.articles;
          this.new_articles = response.data.new_articles;
        });
      }
    },
    startDrag (evt, category) {
      evt.dataTransfer.dropEffect = 'move';
      evt.dataTransfer.effectAllowed = 'move';
      evt.dataTransfer.setData('itemID', category.id);
		},
		onDrop (evt, place) {
			const itemID = evt.dataTransfer.getData('itemID');
      if (this.selected_program) {
        axios.post('/admin/articles/add-new-article-program', {program_id: this.selected_program, category_id: itemID, order: place}).then(response => {
          this.new_articles = response.data;
        });
      } else {
        axios.post('/admin/articles/add-new-article-program-category', {program_category_id: this.selected_program_category, category_id: itemID, order: place}).then(response => {
          this.new_articles = response.data;
        });
      }
		}
  },
}

</script>
